import React from 'react';
import {hydrate} from 'react-dom';
import {Provider} from 'react-redux';
import {App} from '../../shared/App';
import {configureStore} from '../../shared/startup/configureStore';
import AbacusClientUtils from '@homeaway/abacus-client-utils';

window.ha = window.ha || {};
window.ha.prefix = window.location.pathname.split('/')[1];

// As we are loading the bundle asynchronously, we should check if the
// DOM is ready before trying to hook into it

function startApp() {
    const readyState = document.readyState;

    if (!('objectFit' in document.body.style)) {
        import(
            /* webpackChunkName: "object-fit" */
            'object-fit-images'
        ).then(({default: objecFit}) => objecFit());
    }

    /* eslint consistent-return:0 */
    function initReactApp() {
        // Grab the state from a global injected into server-generated HTML
        const preloadedState = window.__PRELOADED_STATE__;

        // Create Redux store with initial state
        const store = configureStore({
            initialState: preloadedState
        });

        const abacus = store.getState().abacus;

        AbacusClientUtils.initialize(abacus);

        hydrate(
            <Provider store={store}>
                <App />
            </Provider>,
            document.querySelector('.app')
        );
    }

    if (readyState === 'interactive' || readyState === 'complete') {
        initReactApp();
    } else {
        document.addEventListener('DOMContentLoaded', initReactApp);
    }

    window.__startApp = null;
}

window.__startApp = startApp;
const polyfilled = window.__polyfilled;

if (polyfilled === true || polyfilled !== false) {
    startApp();
}
